import React, {useRef} from 'react';
import { StyledHeroConfig } from './StyledHeroConfig';


const HeroConfig = () => {
  const wrapper = useRef(null);

  const changeColor = (e,classItem, action) => {
    const parent = e.currentTarget.parentNode;
    const selected = parent.querySelector('.selected');
    const chosen = parent.querySelector(classItem);

    selected.classList.remove('selected');
    chosen.classList.add('selected');
    wrapper.current.querySelector('iframe').contentWindow.postMessage(action, '*');

  }
  return (
    <React.Fragment>
      {
       
          <StyledHeroConfig>
            <div className="iframe-wrap" ref={wrapper}>
              <iframe src="/velasca-commerce/index.html" />
            </div>
            <div className="viewer-row">
              <div className="color-mod color-light selected" onClick={(e) => {changeColor(e, '.color-light', 'setSclB')}}>
                <span></span>
              </div>
              <div className="color-mod color-brown" onClick={(e) => {changeColor(e,'.color-brown', 'setSuclDb')}}>
                <span></span>
              </div>
              <div className="color-mod color-black" onClick={(e) => {changeColor(e, '.color-black', 'setSclK')}}>
                <span></span>
              </div>
            </div>
          </StyledHeroConfig>
          
      }
    </React.Fragment>
  );
};

export default HeroConfig;
